<template>
  <div class="download-report-screen">
    <template v-if="!selectedFormat">
      <div class="download-report-screen__formats">
        <CamsButton priority="primary" type="button" @click="selectFormat('xlsx')">
          {{ $t('downloadReportXLSX') }}
        </CamsButton>
        <CamsButton type="button" @click="selectFormat('csv')">
          {{ $t('downloadReportCSV') }}
        </CamsButton>
      </div>
    </template>
    <template v-else>
      <ReportExportProgress v-if="progress.phase !== 'error'" :progress="progress" />
      <p v-else class="download-report-screen__error" role="alert">
        {{ progress.error }}
      </p>
      <div class="download-report-screen__actions">
        <CamsButton
          v-if="isDownloading && progress.active"
          type="button"
          :disabled="progress.phase === 'cancelling'"
          @click="cancelDownload"
        >
          {{ $t('reportExportCancel') }}
        </CamsButton>
        <CamsButton
          v-if="progress.phase === 'error' || progress.phase === 'cancelled'"
          type="button"
          :disabled="isDownloading || progress.active"
          @click="selectFormat(selectedFormat)"
        >
          {{ $t('retry') }}
        </CamsButton>
        <CamsButton
          v-if="!isDownloading && !progress.active"
          priority="primary"
          type="button"
          @click="finish"
        >
          {{ $t('reportExportOK') }}
        </CamsButton>
      </div>
    </template>
  </div>
</template>

<script>
import {methodsForDialogMixin} from "@/components/pacs/mixins.js";
import ReportExportProgress from "@/components/reports/ReportExportProgress.vue";

export default {
  name: "DownloadReportScreen",
  components: {ReportExportProgress},
  mixins: [methodsForDialogMixin],
  props: {
    progress: {type: Object, required: true},
    onDownload: {type: Function, required: true},
    onCancel: {type: Function, required: true},
  },
  data() {
    return {selectedFormat: null, isDownloading: false};
  },
  methods: {
    async selectFormat(format) {
      if (this.isDownloading || this.progress.active || this.progress.phase === "complete") return;
      this.selectedFormat = format;
      this.isDownloading = true;
      try {
        const success = await this.onDownload(format);
        if (!success && this.progress.phase !== "error" && this.progress.phase !== "cancelled") {
          Object.assign(this.progress, {active: false, phase: "error", error: this.$t('archiveError')});
        }
      } catch (error) {
        Object.assign(this.progress, {active: false, phase: "error", error: error?.message || this.$t('archiveError')});
      } finally {
        this.isDownloading = false;
      }
    },
    cancelDownload() {
      if (this.isDownloading && this.progress.active && this.progress.phase !== "cancelling") this.onCancel();
    },
    finish() {
      if (!this.isDownloading && !this.progress.active) this.closeDialog();
    },
  },
};
</script>

<style scoped lang="scss">
.download-report-screen {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__formats {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    min-height: 36px;
    margin-top: 16px;
  }

  &__error {
    margin: 12px 0;
    color: #b5322d;
    overflow-wrap: anywhere;
  }
}
</style>

<style lang="scss">
.vuedal.report-download-vuedal {
  width: 350px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
  border-radius: 6px;
}

</style>
